import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/icon_note_yellow.svg'
import _imports_1 from '@/assets/img/Icons/x.svg'
import _imports_2 from '@/assets/img/Icons/flash-purple.svg'
import _imports_3 from '@/assets/img/Icons/image-user.svg'


const _withScopeId = n => (_pushScopeId("data-v-08fed753"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-msg" }
const _hoisted_2 = { class: "icon-and-msg" }
const _hoisted_3 = {
  key: 0,
  class: "person-circle"
}
const _hoisted_4 = { class: "btn-moderated" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/img/magic-wand.svg" }, null, -1))
const _hoisted_6 = ["text"]
const _hoisted_7 = ["title"]
const _hoisted_8 = {
  key: 0,
  class: "title"
}
const _hoisted_9 = {
  key: 1,
  class: "title"
}
const _hoisted_10 = {
  key: 2,
  class: "quote"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 0,
  class: "moderated-container--tag"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/img/magic-wand.svg" }, null, -1))
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 1,
  class: "pre-line"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "note-icon",
  src: _imports_0
}, null, -1))
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 0,
  class: "delete-message"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "delete-cross",
  src: _imports_1
}, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "automation-icon",
  src: _imports_2
}, null, -1))
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = {
  key: 2,
  class: "delete-message"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "delete-cross",
  src: _imports_1
}, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "case-update-icon",
  src: _imports_3
}, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "case-assignment-icon",
  src: _imports_3
}, null, -1))
const _hoisted_30 = {
  key: 7,
  class: "pre-line"
}
const _hoisted_31 = {
  key: 0,
  class: "emoji-container"
}
const _hoisted_32 = { class: "info" }
const _hoisted_33 = { class: "name" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot" }, ".", -1))
const _hoisted_35 = ["title"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot" }, ".", -1))
const _hoisted_37 = ["title"]
const _hoisted_38 = { key: 5 }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot" }, ".", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot" }, ".", -1))
const _hoisted_42 = ["data-uk-tooltip"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot" }, ".", -1))
const _hoisted_44 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvatarOrInitials = _resolveComponent("AvatarOrInitials")!
  const _component_Quote = _resolveComponent("Quote")!
  const _component_EmojiReaction = _resolveComponent("EmojiReaction")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.canViewMessage)
      ? (_openBlock(), _createBlock(_Transition, {
          key: 0,
          name: "fade"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["chat-msg-container", { outgoing: _ctx.outgoing }])
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  (!_ctx.outgoing)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_AvatarOrInitials, {
                          user: _ctx.initials,
                          size: 40
                        }, null, 8, ["user"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["bubble", [_ctx.message.type]])
                  }, [
                    _withDirectives(_createElementVNode("div", _hoisted_4, [
                      _hoisted_5,
                      _createElementVNode("a", {
                        text: _ctx.viewCommentText,
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleComment && _ctx.toggleComment(...args)))
                      }, null, 8, _hoisted_6)
                    ], 512), [
                      [_vShow, 
                                    _ctx.isAdmin && _ctx.message?.has_moderated_content
                                ]
                    ]),
                    (_ctx.message && _ctx.message?.type === 'question')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (
                                        _ctx.message?.conversational &&
                                        Object.keys(_ctx.message.conversational)
                                            .length
                                    )
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.message.conversational, (question) => {
                                return _withDirectives((_openBlock(), _createElementBlock("div", {
                                  key: question.key
                                }, [
                                  _createElementVNode("div", {
                                    "data-uk-tooltip": "",
                                    title: 
                                                !_ctx.isAiQuestion(question.key)
                                                    ? _ctx.getQuestionTooltip(
                                                          question.key,
                                                          question
                                                      )
                                                    : null
                                            
                                  }, [
                                    (
                                                    _ctx.isAiQuestion(question.key)
                                                )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(question.question_text), 1))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.friendlyFieldName(
                                                        question.key
                                                    )), 1)),
                                    (_ctx.isAdmin)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                          _createVNode(_Transition, { name: "slide" }, {
                                            default: _withCtx(() => [
                                              (_ctx.showComment)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    innerHTML: 
                                                            _ctx.getQuestionHtml(
                                                                question.key,
                                                                question,
                                                                _ctx.showOriginalComment
                                                            )
                                                        
                                                  }, null, 8, _hoisted_11))
                                                : _createCommentVNode("", true)
                                            ], undefined, true),
                                            _: 2
                                          }, 1024)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (!_ctx.isAdmin)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 3,
                                          class: "quote",
                                          innerHTML: 
                                                    _ctx.getQuestionHtml(
                                                        question.key,
                                                        question
                                                    )
                                                
                                        }, null, 8, _hoisted_12))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_7),
                                  (
                                                (question.key === 'comment' &&
                                                    _ctx.message.original_comment) ||
                                                question?.original_message
                                            )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                        _hoisted_14,
                                        _createTextVNode(" Moderated by NiceAI ")
                                      ]))
                                    : _createCommentVNode("", true)
                                ])), [
                                  [_vShow, _ctx.shouldShowQuestion(question)]
                                ])
                              }), 128))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                innerHTML: _ctx.message.comment
                              }, null, 8, _hoisted_15))
                        ], 64))
                      : (_ctx.message.type === 'review')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.replaceSpecialChars(_ctx.message.message)), 1))
                        : (_ctx.message.type === 'note')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _hoisted_17,
                              _createElementVNode("span", {
                                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickHashtag && _ctx.onClickHashtag(...args))),
                                innerHTML: 
                                        _ctx.nl2br(
                                            _ctx.parseMentionsAndTags(_ctx.message.text)
                                        )
                                    
                              }, null, 8, _hoisted_18),
                              (_ctx.canDeleteNote)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                    _createElementVNode("span", {
                                      class: "uk-text-muted",
                                      "data-uk-tooltip": "",
                                      title: "Delete this note",
                                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.doDeleteNote && _ctx.doDeleteNote(...args)))
                                    }, _hoisted_21)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (_ctx.message.type === 'automation')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _hoisted_22,
                                (_ctx.expanded)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: "cursor",
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.expanded = false)),
                                      innerHTML: _ctx.message.body
                                    }, null, 8, _hoisted_23))
                                  : (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      class: "cursor",
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.expanded = true))
                                    }, _toDisplayString(_ctx.message.message), 1)),
                                (_ctx.secondsToDelete > 0 && _ctx.isUserBasic)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                      _createElementVNode("span", {
                                        class: "uk-text-muted",
                                        "data-uk-tooltip": "",
                                        title: "Delete from queue",
                                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.doDeleteWorkflow && _ctx.doDeleteWorkflow(...args)))
                                      }, _hoisted_26)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (_ctx.isShoutout)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                  _createVNode(_component_Quote, { text: _ctx.questionText }, null, 8, ["text"]),
                                  _createElementVNode("span", {
                                    innerHTML: 
                                        _ctx.decodeHtmlEntities(
                                            _ctx.replaceSpecialChars(_ctx.message.message)
                                        )
                                    
                                  }, null, 8, _hoisted_27)
                                ], 64))
                              : (_ctx.message.type === 'case_update')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                    _hoisted_28,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.message.message), 1)
                                  ], 64))
                                : (_ctx.message.type === 'case_assignment')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                      _hoisted_29,
                                      _createElementVNode("span", null, _toDisplayString(_ctx.message.message), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.decodeHtmlEntities(
                                            _ctx.replaceSpecialChars(_ctx.message.message)
                                        )), 1))
                  ], 2)
                ]),
                (!_ctx.isShoutout)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      (_ctx.hasNetworkConnection)
                        ? (_openBlock(), _createBlock(_component_EmojiReaction, {
                            key: 0,
                            "is-mobile": _ctx.isMobile,
                            class: _normalizeClass({
                                bottom: _ctx.message.type === 'question',
                                top: _ctx.message.type !== 'question',
                                left:
                                    (!_ctx.outgoing &&
                                        _ctx.textLength >
                                            _ctx.maxLengthToReverseDirection) ||
                                    (_ctx.outgoing &&
                                        _ctx.textLength <
                                            _ctx.maxLengthToReverseDirection),
                                right:
                                    (_ctx.outgoing &&
                                        _ctx.textLength >
                                            _ctx.maxLengthToReverseDirection) ||
                                    (!_ctx.outgoing &&
                                        _ctx.textLength <
                                            _ctx.maxLengthToReverseDirection),
                            }),
                            emojis: _ctx.message.emojis,
                            relid: _ctx.message.id,
                            type: _ctx.message.type,
                            firstname: _ctx.customData.user_firstname,
                            "single-mode": 1
                          }, null, 8, ["is-mobile", "class", "emojis", "relid", "type", "firstname"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_32, [
                (_ctx.showMessageUser)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.message.name || _ctx.message.from_name), 1),
                      _hoisted_34
                    ], 64))
                  : _createCommentVNode("", true),
                (
                            _ctx.message.type === 'review' && _ctx.message.review_rating
                        )
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString('⭐'.repeat(_ctx.message.review_rating)) + " Reviewed ", 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (
                            _ctx.message.type === 'automation' && _ctx.secondsToDelete > 0
                        )
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 2,
                      "data-uk-tooltip": "",
                      title: _ctx.message.ftime
                    }, " Sending " + _toDisplayString(_ctx.timeSince(_ctx.message.time)), 9, _hoisted_35))
                  : _createCommentVNode("", true),
                (_ctx.isShoutout && _ctx.secondsToDelete > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _hoisted_36,
                      _createTextVNode("  "),
                      _createVNode(_component_FontAwesomeIcon, {
                        id: "clock-icon",
                        icon: _ctx.faClock
                      }, null, 8, ["icon"]),
                      _createTextVNode(" "),
                      _createElementVNode("span", null, "Scheduled at " + _toDisplayString(_ctx.message.ftime), 1),
                      (!_ctx.isMobile)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "delete-message",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.doDeleteShoutout && _ctx.doDeleteShoutout(...args)))
                          }, " DELETE "))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.secondsToDelete < 0)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 4,
                      class: "time",
                      title: _ctx.message.ftime,
                      "data-uk-tooltip": ""
                    }, _toDisplayString(_ctx.timeSince(_ctx.message.time)), 9, _hoisted_37))
                  : _createCommentVNode("", true),
                (
                            _ctx.message.type === 'review' && _ctx.message.review_rating
                        )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      (_ctx.reviewReplied)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_39, " Published on Reviews site "))
                        : (
                                !_ctx.chatStatus.reply_review || !_ctx.chatStatus.editing
                            )
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              class: "reply-review",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onChangeReplyReview(true)))
                            }, " Write Public Reply "))
                          : _createCommentVNode("", true)
                    ]))
                  : (_ctx.reviewReplied)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                        _hoisted_40,
                        _createTextVNode(" Published on Reviews site ")
                      ], 64))
                    : _createCommentVNode("", true),
                (
                            _ctx.message.type === 'chat' &&
                            _ctx.outgoing &&
                            _ctx.secondsToDelete > 0
                        )
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                      _hoisted_41,
                      _createElementVNode("span", {
                        class: _normalizeClass({ undo: _ctx.undoText === 'Undo' }),
                        "data-uk-tooltip": _ctx.undoText === 'Undo',
                        title: "Unsend this message - but be quick ⌛",
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.undoChat && _ctx.undoChat(...args)))
                      }, _toDisplayString(_ctx.undoText), 11, _hoisted_42)
                    ], 64))
                  : _createCommentVNode("", true),
                (
                            _ctx.outgoing &&
                            _ctx.message.type === 'chat' &&
                            _ctx.message.opened
                        )
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                      _hoisted_43,
                      _createElementVNode("span", {
                        "data-uk-tooltip": "",
                        class: "eyes",
                        title: _ctx.message.fopened
                      }, " 👀 ", 8, _hoisted_44)
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  (_ctx.hasNetworkConnection)
                    ? (_openBlock(), _createBlock(_component_EmojiReaction, {
                        key: 0,
                        class: _normalizeClass({
                                bottom: _ctx.message.type === 'question',
                                top: _ctx.message.type !== 'question',
                                left: _ctx.outgoing,
                                right: !_ctx.outgoing,
                            }),
                        emojis: _ctx.message.emojis,
                        relid: _ctx.message.id,
                        type: _ctx.message.type,
                        firstname: _ctx.customData.user_firstname,
                        "single-mode": 0
                      }, null, 8, ["class", "emojis", "relid", "type", "firstname"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 2)
          ], undefined, true),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}